import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle_3.16552/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/var/jenkins_home/workspace/tingle_3.16552/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/var/jenkins_home/workspace/tingle_3.16552/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export var WEBGATE_DOMAIN = "https://generic.wg.spotify.com";

function createDefaultHeaders(version, pkgVersion) {
  return {
    accept: 'application/json',
    'content-type': 'application/json',
    'spotify-app-version': "".concat(pkgVersion, ".").concat(version),
    'app-platform': 'Browser'
  };
}

var defaultWebgateHeaders = createDefaultHeaders('test', '0.0.0');
var getToken = null;
var hasBeenConfigured = false;
export function configure(options) {
  if (hasBeenConfigured) {
    throw new Error('Cannot configure webgateFetch more than once!');
  }

  getToken = options.getToken;
  defaultWebgateHeaders = createDefaultHeaders(options.version || 'test', options.pkgVersion || '0.0.0');
  hasBeenConfigured = true;
} // visible for testing

export function restore() {
  if (process.env.NODE_ENV !== 'test' && process.env.STORYBOOK_MODE !== 'enabled') {
    throw new Error('Cannot restore webgateFetch in non-test environment');
  }

  hasBeenConfigured = false;
  getToken = null;
  defaultWebgateHeaders = createDefaultHeaders('test', '0.0.0');
}
export function webgateFetch(_x) {
  return _webgateFetch.apply(this, arguments);
}
/**
 * Convenience method that calls webgateFetch, verifies an
 * OK response was returned and extracts JSON from the body.
 */

function _webgateFetch() {
  _webgateFetch = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(input) {
    var options,
        req,
        token,
        headers,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

            if (!(!getToken || !hasBeenConfigured)) {
              _context.next = 3;
              break;
            }

            throw new Error('Cannot webgateFetch without configuration');

          case 3:
            req = new Request(input, options);
            _context.next = 6;
            return getToken();

          case 6:
            token = _context.sent;
            headers = new Headers(defaultWebgateHeaders);
            headers.set('authorization', "Bearer ".concat(token));

            if (options.headers) {
              Object.entries(options.headers).forEach(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                headers.set(key, value);
              });
            }

            return _context.abrupt("return", fetch(new Request(req, {
              headers: headers
            })));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _webgateFetch.apply(this, arguments);
}

export function webgateFetchJson(_x2, _x3) {
  return _webgateFetchJson.apply(this, arguments);
}

function _webgateFetchJson() {
  _webgateFetchJson = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(input, options) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return webgateFetch(input, options);

          case 2:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 5;
              break;
            }

            throw new Error("".concat(response.status, " ").concat(response.url));

          case 5:
            _context2.next = 7;
            return response.json();

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _webgateFetchJson.apply(this, arguments);
}